import { LOCKED_BASIC_FIELDS } from '@features/forms/constants';
import { FormFieldData } from '@features/forms/types';

import { MEMBER_FIELD_CATALOG } from '../constants';

export const FIELD_CATEGORY_DISPLAY_ORDER = [
  'basic',
  'member',
  'custom'
] as const;

export const BASIC_FIELD_DISPLAY_ORDERS = {
  name: 1,
  mobile: 2
} as const;

const normalizeBasicFieldLabel = (label: string) =>
  label.trim().toLowerCase().replace(/\s+/g, ' ');

const sortMemberFieldsForDisplay = (
  memberFields: FormFieldData[]
): FormFieldData[] => {
  const getMemberFieldSortOrder = (field: FormFieldData) => {
    if (field.memberFieldKey) {
      const entry = MEMBER_FIELD_CATALOG.find(
        (catalogEntry) => catalogEntry.key === field.memberFieldKey
      );
      return entry?.order ?? Number.MAX_SAFE_INTEGER;
    }

    return field.order;
  };

  return [...memberFields].sort(
    (left, right) =>
      getMemberFieldSortOrder(left) - getMemberFieldSortOrder(right)
  );
};

export const assignFormFieldDisplayOrders = (
  fields: FormFieldData[]
): FormFieldData[] => {
  const basicByLabel = new Map<string, FormFieldData>();

  fields
    .filter((field) => field.fieldCategory === 'basic')
    .forEach((field) => {
      basicByLabel.set(normalizeBasicFieldLabel(field.label), field);
    });

  const basicFields = LOCKED_BASIC_FIELDS.map((template) => {
    const existing = basicByLabel.get(normalizeBasicFieldLabel(template.label));

    if (!existing) {
      return template;
    }

    return {
      ...template,
      id: existing.id,
      required: existing.required,
      order: template.order
    };
  });

  const customFields = fields
    .filter((field) => field.fieldCategory === 'custom')
    .sort((left, right) => left.order - right.order);

  const memberFields = sortMemberFieldsForDisplay(
    fields.filter((field) => field.fieldCategory === 'member')
  );

  const memberStartOrder = LOCKED_BASIC_FIELDS.length + 1;

  const memberWithOrder = memberFields.map((field, index) => ({
    ...field,
    order: memberStartOrder + index
  }));

  const customStartOrder = memberStartOrder + memberFields.length;

  const customWithOrder = customFields.map((field, index) => ({
    ...field,
    order: customStartOrder + index
  }));

  return [...basicFields, ...memberWithOrder, ...customWithOrder];
};
